import TextCopy from "../../../../../components/common/TextCopy";
import type { MailRule } from "../../../api/connectionHub.types";
import styles from "./OutlookRulesPanel.module.scss";

/** What to type into an Outlook rule: its name, the condition values and the redirect address. */
const MailRuleFields = ({ rule }: { rule: MailRule }): JSX.Element => (
  <>
    <div className={styles.field}>
      <span className={styles.fieldLabel}>Name:</span>
      <TextCopy iconOnlyFeedback text={rule.name} className={styles.chip} />
    </div>

    <div className={styles.field}>
      <span className={styles.fieldLabel}>
        {rule.conditionLabel}:
        {rule.valuesAddedSeparately ? <em className={styles.hint}>Add each separately</em> : null}
      </span>
      <span className={styles.values}>
        {rule.valuesAddedSeparately
          ? rule.conditionValues.map((value) => <TextCopy iconOnlyFeedback text={value} className={styles.chip} key={value} />)
          : <TextCopy iconOnlyFeedback text={rule.conditionValues.join(", ")} className={styles.chip} />}
      </span>
    </div>

    <div className={styles.field}>
      <span className={styles.fieldLabel}>Redirect to:</span>
      <TextCopy iconOnlyFeedback text={rule.redirectTo} className={styles.chip} />
    </div>
  </>
);

export default MailRuleFields;
